
































import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Dynamic extends Vue {
  @Prop()
  dynamicList!: any;
  index = 0;

  setSelcted(index) {
    (this.$refs.carousel as any).setActiveItem(index);
  }
  dynamiCprev(e) {
    (this.$refs.carousel as any).prev();
  }
  dynamicNext(e) {
    (this.$refs.carousel as any).next();
  }
}
